<div class="not-found-wrapper">
    <div class="not-found-responsive">
        <img src="https://media.winstonfinancial.com/Stingray/Images/yeti_with_error.png" alt="404 Error" class="not-found-responsive">

    </div>
    <div class="not-found-responsive not-found-button-wrapper">

        <button 
           class="button-flat"
           (click)="navigateBack()">BACK</button>

    </div>
    <div class="not-found-push"></div>
</div>
<footer class="not-found-footer"><p class="not-found-copyright-p">&copy; {{copyrightYear}} Winston. All Rights Reserved.</p></footer>
